module.exports = __webpack_public_path__ + "static/NudistaThin-f19e07a716b4fe58b2b66c87fa92334e.ttf";